import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  AppLocale,
  DEFAULT_APP_LOCALE,
  LOCALE_STORAGE_KEY,
  isAppLocale,
} from './types';
import frCommon from './locales/fr/common.json';
import enCommon from './locales/en/common.json';
import frStatus from './locales/fr/status.json';
import enStatus from './locales/en/status.json';
import frMarketing from './locales/fr/marketing.json';
import enMarketing from './locales/en/marketing.json';
import frMessagesClients from './locales/fr/messagesClients.json';
import enMessagesClients from './locales/en/messagesClients.json';
import frNotifications from './locales/fr/notifications.json';
import enNotifications from './locales/en/notifications.json';
import frErrors from './locales/fr/errors.json';
import enErrors from './locales/en/errors.json';
import frForms from './locales/fr/forms.json';
import enForms from './locales/en/forms.json';
import frPos from './locales/fr/pos.json';
import enPos from './locales/en/pos.json';
import frClients from './locales/fr/clients.json';
import enClients from './locales/en/clients.json';
import frInventory from './locales/fr/inventory.json';
import enInventory from './locales/en/inventory.json';
import frDocuments from './locales/fr/documents.json';
import enDocuments from './locales/en/documents.json';
import frDocumentation from './locales/fr/documentation.json';
import enDocumentation from './locales/en/documentation.json';
import frHr from './locales/fr/hr.json';
import enHr from './locales/en/hr.json';
import frPurchases from './locales/fr/purchases.json';
import enPurchases from './locales/en/purchases.json';
import frAccounting from './locales/fr/accounting.json';
import enAccounting from './locales/en/accounting.json';
import frActivity from './locales/fr/activity.json';
import enActivity from './locales/en/activity.json';
import frOperations from './locales/fr/operations.json';
import enOperations from './locales/en/operations.json';
import frSettings from './locales/fr/settings.json';
import enSettings from './locales/en/settings.json';
import frLanding from './locales/fr/landing.json';
import enLanding from './locales/en/landing.json';
import frCatalogPacks from './locales/fr/catalogPacks.json';
import enCatalogPacks from './locales/en/catalogPacks.json';

export { DEFAULT_APP_LOCALE, LOCALE_STORAGE_KEY, isAppLocale };
export type { AppLocale };

const resources = {
  fr: {
    common: frCommon,
    status: frStatus,
    marketing: frMarketing,
    messagesClients: frMessagesClients,
    notifications: frNotifications,
    errors: frErrors,
    forms: frForms,
    pos: frPos,
    clients: frClients,
    inventory: frInventory,
    documents: frDocuments,
    documentation: frDocumentation,
    hr: frHr,
    purchases: frPurchases,
    accounting: frAccounting,
    activity: frActivity,
    operations: frOperations,
    settings: frSettings,
    landing: frLanding,
    catalogPacks: frCatalogPacks,
  },
  en: {
    common: enCommon,
    status: enStatus,
    marketing: enMarketing,
    messagesClients: enMessagesClients,
    notifications: enNotifications,
    errors: enErrors,
    forms: enForms,
    pos: enPos,
    clients: enClients,
    inventory: enInventory,
    documents: enDocuments,
    documentation: enDocumentation,
    hr: enHr,
    purchases: enPurchases,
    accounting: enAccounting,
    activity: enActivity,
    operations: enOperations,
    settings: enSettings,
    landing: enLanding,
    catalogPacks: enCatalogPacks,
  },
};

/** Lit la locale stockée localement (sans auth). */
export function readStoredLocale(): AppLocale | null {
  if (typeof window === 'undefined') return null;
  try {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    return isAppLocale(stored) ? stored : null;
  } catch {
    return null;
  }
}

export function persistLocale(locale: AppLocale): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // ignore quota / private mode
  }
}

/** Résolution initiale : localStorage → défaut FR. */
export function resolveInitialLocale(): AppLocale {
  return readStoredLocale() ?? DEFAULT_APP_LOCALE;
}

void i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLocale(),
  fallbackLng: DEFAULT_APP_LOCALE,
  defaultNS: 'common',
  ns: [
    'catalogPacks','common', 'status', 'marketing', 'messagesClients', 'notifications', 'errors', 'forms', 'pos', 'clients', 'inventory', 'documents', 'documentation', 'hr', 'purchases', 'accounting', 'activity', 'operations', 'settings', 'landing'],
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
